import { createLazyFileRoute } from "@tanstack/react-router";

import { InstrumentsPage } from "@/features/admin/routes/Instruments";

export const Route = createLazyFileRoute("/_auth/admin/instruments/")({
  component: InstrumentsPage,
});
